import React, { useEffect, useState } from "react";
import { WifiOff, RefreshCw } from "lucide-react";
import { useLang } from "@/i18n";

/* Shown when the browser is offline or the API stopped answering — so a tap never fails silently. */
export default function OfflineBanner() {
  const { t } = useLang();
  const [offline, setOffline] = useState(!navigator.onLine);
  const [apiDown, setApiDown] = useState(false);
  useEffect(() => {
    const on = () => { setOffline(false); setApiDown(false); };
    const off = () => setOffline(true);
    const down = () => setApiDown(true);
    const up = () => setApiDown(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    window.addEventListener("gf:api-down", down); window.addEventListener("gf:api-up", up);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); window.removeEventListener("gf:api-down", down); window.removeEventListener("gf:api-up", up); };
  }, []);
  if (!offline && !apiDown) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-rose-600 text-white text-sm font-medium px-4 py-2 flex items-center justify-center gap-2 shadow-lg" data-testid="offline-banner">
      {offline ? <WifiOff className="h-4 w-4" /> : <RefreshCw className="h-4 w-4 animate-spin" />}
      {offline ? t("offlineBanner") : t("apiRetryBanner")}
    </div>
  );
}
